import { createIconComponent } from '../../factory/create-icon-component';
export const ArrowRightShortIcon = createIconComponent(
  'ArrowRightShortIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6L13.7373 9.73726C14.5293 10.5293 14.9253 10.9253 15.0737 11.382C15.2042 11.7837 15.2042 12.2163 15.0737 12.618C14.9253 13.0747 14.5293 13.4707 13.7373 14.2627L10 18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
